
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/pdf-summarizer",
      function () {
        return require("private-next-pages/tools/pdf-summarizer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/pdf-summarizer"])
      });
    }
  